module.exports = __webpack_public_path__ + "img/spiderhomecoming.4f48af30.svg";